import { clamp } from "./math";

export function throttle(func, delay, options = null) {
	let lastCall = options?.lastCall ?? 0;
	let timeoutId = null;
	let startData = null;

	return function (...args) {
		const now = Date.now();
		const ellapsedTime = now - lastCall;
		const waitTime = clamp(0, Infinity, delay - Math.abs(ellapsedTime));

		function endTimer() {
			options?.end?.(startData);
			startData = null;
			timeoutId = null;
		}

		if (ellapsedTime >= delay) {
			const result = func.apply(this, args);
			if (result) {
				clearTimeout(timeoutId);
				endTimer();
				return;
			}
			lastCall = now;
			if (timeoutId) {
				clearTimeout(timeoutId);
				timeoutId = null;
				startData = null;
			}
		}

		if (!timeoutId) {
			startData = options?.start?.(delay, lastCall);
			timeoutId = setTimeout(() => {
				endTimer();
			}, delay);
		}
	};
}

export function wait(delay) {
	return new Promise(resolve => setTimeout(() => resolve(), delay));
}

export function debounce(func, delay) {
	let timeoutId;

	return async function (...args) {
		clearTimeout(timeoutId);
		return new Promise(resolve => {
			let response = null;
			timeoutId = setTimeout(() => {
				response = func.apply(this, args);
				resolve(response);
			}, delay);
		});
	};
}